import { ExperListParams, ExpertListResponse } from "../types/experts"

export class Experts {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }

  list(
    queryParams?: ExperListParams,
    headers?: Record<string, string>
  ): Promise<ExpertListResponse> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/experts`, {
        headers,
        query: queryParams,
      })
    })()
  }
}
